<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9589 21.5C17.2055 21.5228 21.4772 17.2879 21.4999 12.0413C21.5226 6.7946 17.2878 2.52293 12.0411 2.50021C6.79448 2.4775 2.52281 6.71234 2.50009 11.959C2.49391 13.3865 2.80291 14.7419 3.36172 15.9591C3.78667 16.8847 3.54122 20.4591 3.54122 20.4591C3.54122 20.4591 7.37096 20.4425 8.83199 20.9591C9.81036 21.305 10.8625 21.4953 11.9589 21.5ZM11.9676 19.3508C16.0268 19.3683 19.3317 16.0919 19.3493 12.0327C19.3669 7.9734 16.0905 4.66848 12.0312 4.6509C7.97195 4.63333 4.66703 7.90976 4.64945 11.969C4.64467 13.0735 4.88374 14.1221 5.31608 15.0638C5.64486 15.78 5.45496 18.5454 5.45496 18.5454C5.45496 18.5454 8.41797 18.5326 9.54834 18.9322C10.3053 19.1999 11.1193 19.3471 11.9676 19.3508Z" :fill="color"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.1998 12.0002C9.1998 12.6629 8.66255 13.2002 7.9998 13.2002C7.33706 13.2002 6.7998 12.6629 6.7998 12.0002C6.7998 11.3374 7.33706 10.8002 7.9998 10.8002C8.66255 10.8002 9.1998 11.3374 9.1998 12.0002ZM13.1998 12.0002C13.1998 12.6629 12.6625 13.2002 11.9998 13.2002C11.3371 13.2002 10.7998 12.6629 10.7998 12.0002C10.7998 11.3374 11.3371 10.8002 11.9998 10.8002C12.6625 10.8002 13.1998 11.3374 13.1998 12.0002ZM15.9998 13.2002C16.6625 13.2002 17.1998 12.6629 17.1998 12.0002C17.1998 11.3374 16.6625 10.8002 15.9998 10.8002C15.3371 10.8002 14.7998 11.3374 14.7998 12.0002C14.7998 12.6629 15.3371 13.2002 15.9998 13.2002Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgTalk',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
